import {
  FETCH_SENGAGE_DATA_INIT,
  FETCH_SENGAGE_DATA_SUCCESS,
  FETCH_SENGAGE_DATA_FAIL,
  FETCH_SENGAGE_TIMELINE_DATA_INIT,
  FETCH_SENGAGE_TIMELINE_DATA_SUCCESS,
  FETCH_SENGAGE_TIMELINE_DATA_FAIL,
  FETCH_SENGAGE_CAMPAIGN_FRAMES_INIT,
  FETCH_SENGAGE_CAMPAIGN_FRAMES_SUCCESS,
  FETCH_SENGAGE_CAMPAIGN_FRAMES_FAIL,
  FETCH_TIMING_PATTERNS_INIT,
  FETCH_TIMING_PATTERNS_SUCCESS,
  FETCH_TIMING_PATTERNS_FAIL,
  FETCH_OUTLET_RANKING_INIT,
  FETCH_OUTLET_RANKING_SUCCESS,
  FETCH_OUTLET_RANKING_FAIL,
  FETCH_PROMO_MECHANICS_INIT,
  FETCH_PROMO_MECHANICS_SUCCESS,
  FETCH_PROMO_MECHANICS_FAIL,
} from './constants';

const initialState = {
  sengageData: {
    data: null,
    loading: false,
    error: null,
  },
  sengageTimelineData: {
    data: null,
    loading: false,
    error: null,
  },
  /** Each item: `{ campaign, records: [{ start_date, end_date_final, message_sent_count }] }` */
  sengageCampaignFrames: {
    data: null,
    loading: false,
    error: null,
  },
  /** Day-part × day return-visit heatmap from `/timing_patterns`. */
  timingPatterns: {
    data: null,
    loading: false,
    error: null,
  },
  /** Outlet performance ranking from `/outlet_ranking`. */
  outletRanking: {
    data: null,
    loading: false,
    error: null,
  },
  /** Returns/Redemptions by promo mechanics — per-campaign tier comparison (`/promo_mechanics`). */
  promoMechanics: {
    data: null,
    loading: false,
    error: null,
  },
};

const smartEngageReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SENGAGE_DATA_INIT:
      return {
        ...state,
        sengageData: {
          ...state.sengageData,
          loading: true,
          error: null,
        },
      };
    case FETCH_SENGAGE_DATA_SUCCESS:
      return {
        ...state,
        sengageData: {
          ...state.sengageData,
          loading: false,
          data: action.payload,
        },
      };
    case FETCH_SENGAGE_DATA_FAIL:
      return {
        ...state,
        sengageData: {
          ...state.sengageData,
          loading: false,
          error: action.error,
        },
      };
    case FETCH_SENGAGE_TIMELINE_DATA_INIT:
      return {
        ...state,
        sengageTimelineData: {
          ...state.sengageTimelineData,
          loading: true,
          error: null,
        },
      };
    case FETCH_SENGAGE_TIMELINE_DATA_SUCCESS:
      return {
        ...state,
        sengageTimelineData: {
          ...state.sengageTimelineData,
          loading: false,
          data: action.payload,
        },
      };
    case FETCH_SENGAGE_TIMELINE_DATA_FAIL:
      return { ...state, sengageTimelineData: { ...state.sengageTimelineData, loading: false, error: action.error } };
    case FETCH_SENGAGE_CAMPAIGN_FRAMES_INIT:
      return {
        ...state,
        sengageCampaignFrames: {
          ...state.sengageCampaignFrames,
          loading: true,
          error: null,
        },
      };
    case FETCH_SENGAGE_CAMPAIGN_FRAMES_SUCCESS:
      return {
        ...state,
        sengageCampaignFrames: {
          ...state.sengageCampaignFrames,
          loading: false,
          data: action.payload,
        },
      };
    case FETCH_SENGAGE_CAMPAIGN_FRAMES_FAIL:
      return {
        ...state,
        sengageCampaignFrames: {
          ...state.sengageCampaignFrames,
          loading: false,
          error: action.error,
        },
      };
    case FETCH_TIMING_PATTERNS_INIT:
      return {
        ...state,
        timingPatterns: { ...state.timingPatterns, loading: true, error: null },
      };
    case FETCH_TIMING_PATTERNS_SUCCESS:
      return {
        ...state,
        timingPatterns: { ...state.timingPatterns, loading: false, data: action.payload },
      };
    case FETCH_TIMING_PATTERNS_FAIL:
      return {
        ...state,
        timingPatterns: { ...state.timingPatterns, loading: false, error: action.error },
      };
    case FETCH_OUTLET_RANKING_INIT:
      return {
        ...state,
        outletRanking: { ...state.outletRanking, loading: true, error: null },
      };
    case FETCH_OUTLET_RANKING_SUCCESS:
      return {
        ...state,
        outletRanking: { ...state.outletRanking, loading: false, data: action.payload },
      };
    case FETCH_OUTLET_RANKING_FAIL:
      return {
        ...state,
        outletRanking: { ...state.outletRanking, loading: false, error: action.error },
      };
    case FETCH_PROMO_MECHANICS_INIT:
      return {
        ...state,
        promoMechanics: { ...state.promoMechanics, loading: true, error: null },
      };
    case FETCH_PROMO_MECHANICS_SUCCESS:
      return {
        ...state,
        promoMechanics: { ...state.promoMechanics, loading: false, data: action.payload },
      };
    case FETCH_PROMO_MECHANICS_FAIL:
      return {
        ...state,
        promoMechanics: { ...state.promoMechanics, loading: false, error: action.error },
      };
    default:
      return state;
  }
};

export default smartEngageReducer;